import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import organizationsIcon from "../../Common/_assets/icons/icon_module_organizations.svg";
import dropdownIcon from "../../Everou/_assets/appIcons/dropdown_white.svg";
import { Selectors } from "../../Everou/_reducers/app.reducer";
import { Organization } from "../../Organizations/_models/Organization";
import { PMSActiveOrganizationStore } from "../_stores/PMSActiveOrganizationStore";

type Props = {
    activeOrganization: Organization | null;
};

// Shows the organization the PMS is operating on (branding, Customization and
// Integrations all follow it) and, with several, lets it be switched from any
// screen — the module pickers only reach it from Customization/Integrations.
// Mirrors UserDropdown, its neighbour in the header: click to open, close on
// mouse leave.
export function PMSHeaderOrganizationPicker({ activeOrganization }: Props) {
    const dispatch = useDispatch();

    const organizations: Organization[] = useSelector(
        Selectors.getOrganizations,
    );
    const [isOpen, setIsOpen] = useState(false);

    if (!activeOrganization) return null;

    const canSwitch = organizations.length > 1;

    return (
        <div
            // No text-truncate here: it sets overflow:hidden, which clips the
            // absolutely-positioned dropdown to this one-line box. The name
            // itself truncates instead (same split as UserDropdown).
            className={`
                d-flex
                align-items-center
                text-light
                mr-3
                position-relative
                ${canSwitch ? "cp" : ""}
            `}
            onClick={() => canSwitch && setIsOpen(!isOpen)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <img
                src={organizationsIcon}
                alt=""
                className="c-img-1-25rem mr-2 flex-shrink-0"
                // Black-stroke SVG from the sidebar; invert it to read on the
                // dark header, same as the other icons on dark backgrounds.
                style={{ filter: "invert(1)" }}
            />
            <span className="text-truncate">{activeOrganization.name}</span>
            {canSwitch && (
                <img
                    className="c-img-1-25rem flex-shrink-0"
                    src={dropdownIcon}
                    alt="dropdown icon"
                />
            )}
            {canSwitch && dropdown(activeOrganization)}
        </div>
    );

    // Takes the active organization as an argument: the early return above
    // narrows it away from null, but that narrowing doesn't reach a closure.
    function dropdown(active: Organization) {
        return (
            <div
                className={`
                    mt-0
                    dropdown-menu
                    dropdown-menu-right
                    ${isOpen ? "show" : ""}
                    c-new-ft-m
                `}
                style={{ top: "100%" }}
            >
                {organizations.map((organization) => (
                    <button
                        key={organization.uid}
                        className={`dropdown-item ${
                            organization.uid === active.uid ? "active" : ""
                        }`}
                        onClick={() =>
                            dispatch(
                                PMSActiveOrganizationStore.actionSet(
                                    organization.uid,
                                ),
                            )
                        }
                    >
                        {organization.name}
                    </button>
                ))}
            </div>
        );
    }
}
